<template>
  <Frame>
    <PageHeader :title="$t('comm.APSearch')" :hasBack="false" />
    <div class="APSearch" style="padding:10px 0 0;">
      <div class="ARmessage">
        <span class="detialmessage"><span style="margin: auto 0;">{{ $t('APSearch.messagedate') }}：</span>
        <el-date-picker v-model="date" type="daterange"
                        :picker-options="PickerOptions"
            style="min-width: 215px; color:#bbbbbb;width: 100%;" range-separator="~" :start-placeholder="$t('comm.startdate')" :default-value="timeDefault"
            :unlink-panels="true" :end-placeholder="$t('comm.enddate')" @change="gettime()" size="small"></el-date-picker>
          </span>
        <!-- <span class="detialmessage" v-if="$store.state.ShowComp"><span style="margin: auto 0;">{{ $t('APSearch.compName') }}：</span><el-input :placeholder="$t('APSearch.inputpls')" v-model="compName" 
          clearable style="color:#bbbbbb;" @change="search(0)" size="small"></el-input></span> -->
        <span class="checkbox-group">
          <el-checkbox v-model="showPreRecAmount" v-if="!IsA10" :disabled="isDisabled" :label="$t('APSearch.preRecOAmountCheckText')"></el-checkbox>
          <el-checkbox v-model="ShowUnZeroItem" v-if="!IsA10" :disabled="isDisabled" :label="$t('APSearch.ShowUnZeroItem')"></el-checkbox>
          <el-checkbox v-model="ShowUnZeroEnd" :disabled="isDisabled" :label="$t('APSearch.ShowUnZeroEnd')"></el-checkbox>
        </span>   
        <span class="querybtn">
          <el-button type="primary" @click="query()" style="padding: 8px 20px;">{{ $t('button.query') }}</el-button>
        </span>
      </div>
      <div class="ARmessage" v-if="WOByOrder">
        <span class="detialmessage" style="min-width: 257px;"><span style="margin: auto 0;">{{ $t('APSearch.FromBillNo') }}：</span><el-input :placeholder="$t('APSearch.inputpls')" v-model="OrderBillNo" 
          clearable style="color:#bbbbbb;" size="small"></el-input></span>
      </div>
      <el-table ref="multipleTable" :data="tableData" :height="tableHeight" v-loading="tableLoading"
        :summary-method="getSummaries" show-summary style="margin:24px 0 0;width:100%" tooltip-effect="dark">
        <!-- <el-table-column prop="CompName" v-if="$store.state.ShowComp" :label="$t('APSearch.compName')" ></el-table-column> -->
        <el-table-column v-if="WOByOrder" prop="OrderBillNo" :label="$t('APSearch.FromBillNo')" ></el-table-column>
        <el-table-column prop="billtype" :label="$t('APSearch.documenttype')" ></el-table-column>
        <el-table-column prop="billno" :label="$t('APSearch.messagenumber')" ></el-table-column>
        <el-table-column prop="billdate" :width="WidthControl('billdate',tableData,6,-20)" :label="$t('APSearch.date')" ></el-table-column>
        <el-table-column v-if="showPreRecAmount" prop="preRecOAmount" align="right" :label="$t('APSearch.preRecOAmount')" >
          <template slot-scope="scope">
            <span>{{ scope.row.preRecOAmount | MoneyFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="amountreceivable" align="right" :label="$t('APSearch.amountreceivable')" >
          <template slot-scope="scope">
            <span>{{ scope.row.amountreceivable | MoneyFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="currentamount" align="right" :label="$t('APSearch.currentamount')" >
          <template slot-scope="scope">
            <span>{{ scope.row.currentamount | MoneyFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="discountamount" align="right" :label="$t('APSearch.discountamount')" v-if="!IsA10" >
          <template slot-scope="scope">
            <span>{{ scope.row.discountamount | MoneyFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unoffsetoamount" align="right" :label="$t('APSearch.lateamount')" >
          <template slot-scope="scope">
            <span>{{ scope.row.unoffsetoamount | MoneyFormat }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </Frame>
</template>

<script>
import { getTimeoutVal } from '@/utils/utils.js'
import { handleShortDate, datePickerOptions } from '@/utils/handleDate.js'
import SvgIcon from '@/components/SvgIcon'
export default {
  name: 'APSearch',
  components: { SvgIcon },
  data() {
    return {
      PickerOptions:datePickerOptions(this),
      OrderBillNo:'',
      WOByOrder:false,
      isDisabled: false, //复选框按钮不可编辑
      tableLoading: false,
      tableHeight: window.innerHeight - 314,
      date: '',
      compName:'',
      startdate: '',
      enddate: '',
      showPreRecAmount: sessionStorage.getItem("VersionType")=="A10",
      ShowUnZeroEnd:false,
      ShowUnZeroItem:!(sessionStorage.getItem("VersionType")=="A10"),
      timeDefault:'',
      IsA10:sessionStorage.getItem("VersionType")=="A10",
      tableData: [{
        billtype: '',
        billno: '',
        billdate: '',
        amountreceivable: '',
        currentamount: '',
        discountamount: '',
        unoffsetoamount: '',
      }]
    }
  },
  mounted() {
    let that = this;
    window.onresize = () => {
      if (that.resizeFlag) {
        clearTimeout(that.resizeFlag);
      }
      that.resizeFlag = setTimeout(() => {
        if(that.WOByOrder){
          that.tableHeight = window.innerHeight - 314;
        }else{
          that.tableHeight = window.innerHeight - 264;
        }
        that.resizeFlag = null;
      }, 100);
    }
    this.timeDefault =new Date();
    this.timeDefault.setMonth(new Date().getMonth()-1);
    //同旧版 进入页面时默认取近一个月的数据
    this.startdate = handleShortDate(new Date(new Date().getTime() - 30 * 3600 * 24 * 1000), "From");
    this.enddate = handleShortDate(new Date(), "From");
    this.date = [new Date(new Date().getTime() - 30 * 3600 * 24 * 1000), new Date()];
    this.getinfo();
  },
  methods: {
    gettime() {
      if(!this.date) {
        this.startdate = "00000000";
        this.enddate = "99999900";
        //this.getinfo();
        return;
      }
      this.startdate = handleShortDate(this.date[0], "From");
      this.enddate = handleShortDate(this.date[1], "To");
      //this.getinfo();
    },
    getinfo() {
      //获取页面数据
      var timeVal= getTimeoutVal(); //设置计时器统一时间 //控制复选框更新频率500毫秒
      this.isDisabled = true;
      setTimeout(() =>{ 
                this.isDisabled = false;
            },timeVal);
      this.tableLoading = true;
      this.axiosInvoke(this.sysHandlerUrl,
        {
          action: "getarfunddetailrpt",
          dateRangeEnd: this.enddate,
          dateRangeBegin: this.startdate,
          showPreRecAmount: this.showPreRecAmount,
          compName:this.compName,
          ShowUnZeroEnd:this.ShowUnZeroEnd,
          ShowUnZeroItem:this.ShowUnZeroItem,
          OrderBillNo:this.OrderBillNo
        },
        (res,errflag) => {
        if(errflag) { this.tableLoading = false; this.tableData = null; return;}
        var data = eval(res.data);
        if(data.length){
          this.WOByOrder = data[0].WOByOrder;
          data.shift();
          if(!this.WOByOrder){
            this.tableHeight = window.innerHeight - 264;
          }
        }
        for(var i=0;i<data.length;i++){
          if(data[i].billtype == "") data[i].billtype = this.$t('APSearch.billTypeAuto') // "期初应付";
          if(data[i].billtype.indexOf(this.$t('APSearch.typeNameYF')) >= 0 ){
            data[i].billtype = data[i].billtype.replace(this.$t('APSearch.typeNameYF'),this.$t('APSearch.typeNameYS'));
          }
          if(data[i].billtype.indexOf(this.$t('APSearch.typeNameYuF')) >= 0){
            data[i].billtype = data[i].billtype.replace(this.$t('APSearch.typeNameYuF'),this.$t('APSearch.typeNameYuS'));
          }
        }
        this.tableData = data;
        this.tableLoading = false;
      }
      )
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t("APSearch.summary");
          return;
        }
        if (index == 1 || index == 2 || (this.WOByOrder && index == 3)) return;
        sums[index] = 0
        var decimallength = 0;
        if(data.length){
          var numlist = data[0][column.property].split('.');
          if(numlist && numlist.length>1){
            decimallength = numlist[1].length;
          }
        }
        data.forEach(v=>{
          if(v[column.property] != "-----") {
            sums[index] += Number(v[column.property].replace(/,/g,""));
          }
        })
        let sumstr = String(Number(sums[index]).toFixed(decimallength));
        sums[index] = sumstr.substring(0,sumstr.indexOf(".")).replace(/\B(?=(\d{3})+(?!\d))/g,",")+sumstr.substring(sumstr.indexOf(".")); 
      });
      return sums;
    },
    query() {//查询
      this.getinfo();
    },
    //加载el-tooltip信息，鼠标聚焦时显示完整信息
    renderTitle (h,{column}) {
      let titleValue = '';
      let columnRealWidth = column.realWidth;
      switch(column.property){
          case'billtype':
              titleValue = this.$t("APSearch.documenttype");
          break;
          case'billno':
              titleValue = this.$t("APSearch.messagenumber");
          break;
          case'CompName':
              titleValue = this.$t("APSearch.compName");
          break;
          case'billdate':
              titleValue = this.$t("APSearch.date");
          break;
          case'amountreceivable':
              titleValue = this.$t("APSearch.amountreceivable");
          break;
          case'preRecOAmount':
              titleValue = this.$t("APSearch.preRecOAmount");
          break;
          case'currentamount':
              titleValue = this.$t("APSearch.currentamount");
          break;
          case'discountamount':
              titleValue = this.$t("APSearch.discountamount");
          break;
          case'unoffsetoamount':
              titleValue = this.$t("APSearch.lateamount");
          break;
          default:
              titleValue = 'APSearch默认栏位信息（测试）'
              break;
      }
      return this.renderTooltip(h,titleValue,columnRealWidth)
    }
  }
}
</script>

<style scoped>
.detialmessage {
  color: #5d5d5d;
  font-size: 14px;
  width: 20%;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  min-width: 245px;
}

.ARmessage {
  padding: 10px 20px;
  width: calc( 100% - 40px );
  display: flex;
}

.el-checkbox /deep/ .el-checkbox__label {
  color: #5d5d5d;
  font-size: 14px;
}

.el-table /deep/ .el-table__header .cell {
    overflow: hidden;
    white-space: nowrap;
}

.el-table /deep/ th.el-table__cell {
  background-color: #f9f9f9;
}

.el-table /deep/ .el-table__body-wrapper {
  font-size: 13px;
}

.el-table /deep/ thead {
  font-size: 14px;
  color: #5d5d5d;
}

.topbutton {
  color: #777777;
  font-size: 14px;
}
.checkbox-group{
  padding-left:50px;
}
.querybtn{
  padding-right:10px;
  margin-left: auto;
}
@media screen and (max-width: 1600px) {
  .querybtn{
    padding-left:30px;
  }
  .checkbox-group{
  padding-left:15px;
 }
 .checkbox-group .el-checkbox{
  margin-right: 15px;
 }
}
@media screen and (max-width: 1350px) {
  .querybtn{
    padding-left:0px;
  }
  .ARmessage{
    padding: 10px 0;
  }
  .checkbox-group{
  padding-left:0px;
 }
 .checkbox-group .el-checkbox{
  margin-right: 5px;
 }
}
</style>
